define('views/AboutView',[
    'backbone',
    'text!templates/about.html',
    'lodash',
    'app',
    'lib/Four',
    'lib/MouseAnim',
    'lib/easing'
], function (Backbone, aboutTmpl, _, App, Four, MouseAnim, easing) {

    "use strict";

    var zeroToOne = function (num) {
        return num > 1 ? 1 : (num < 0 ? 0 : num);
    };

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(aboutTmpl),

        render: function () {
            this.$el.html(this.template(App));
            this.initFour();
        },

        initFour: function () {
            var $canvas = this.$el.find('#invert-four'),
                four = this.four = new Four($canvas[0], App.asset('img/50Varick-F4-1180w.jpg'), 30),
                appendTri = this.$el.find('.j01 .right-tri')[0],
                j02 = this.$el.find('.j02'),
                j02Tri = this.$el.find('.j02 .right-tri'),
                j03 = this.$el.find('.j03'),
                j03Tri = this.$el.find('.j03 .right-tri');

            this.mouseAnim = new MouseAnim();

            /*
                TODO: Clean this up! This is too long and unreadable!
             */
            four.defer.done(_.bind(function () {
                four.to(50, 1000, easing.easeInOutQuart);
                this.mouseAnim.add(function (pos) {
                    // j01
                    var offset = $canvas.offset(),
                        center = {
                            x: offset.left + ($canvas[0].offsetHeight/2),
                            y: offset.top + ($canvas[0].offsetWidth/2)
                        },
                        moved = pos.mousePos.x - center.x + pos.mousePos.y - center.y,
                        max = four.shapes[0].four.h * 6;

                    var progress = zeroToOne( ((moved / max) + 1) / 2 );
                    var tDiff = easing.easeInOutCubic(progress) * 80 + 20;
                    
                    four.to(tDiff);
                    appendTri.style.width = Math.round(four.divideLine.bottom) + 'px';

                    // j02
                    var j02Offset = j02.offset(),
                        yDist = j02Offset.top - offset.top - four.height, // Distance between j01 and j02
                        j02TopTriW = four.divideLine.bottom - (yDist / 1.468),
                        j02BottomTriW = 1 - (easing.easeInOutCubic(progress) * 0.9); // in pencentage of width

                    j02Tri[0].style.width = Math.round(j02BottomTriW * four.width) + 'px';
                    j02Tri[1].style.width = Math.round((1 - j02BottomTriW) * four.width) + 'px';
                    j02Tri[2].style.width = Math.round(j02TopTriW <= 0 ? 0 : j02TopTriW) + 'px';

                    // j03
                    var yDist2to3 = j03.offset().top - j02Offset.top,
                        j03TriW = j02BottomTriW * four.width + (yDist2to3 / 1.468);
                    
                    j03Tri[0].style.width = Math.round(j03TriW) + 'px';
                    j03Tri[1].style.width = Math.round(j03TriW * 0.5) + 'px';
                    j03Tri[2].style.width = Math.round(j03TriW * 0.2) + 'px';
                });
            }, this));
        },

        remove: function () {
            if (this.four) {
                this.four.remove();
            }
            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            Backbone.View.prototype.remove.call(this);
        }

    });

});
